import logo from "../../Assets/logo192.png";
import "./ErrorPage.scss";
import { useTranslation } from "react-i18next";
import { DefaultButton } from "@fluentui/react";
import { FallbackProps } from "react-error-boundary";

const ErrorPage = ({ error, resetErrorBoundary }: FallbackProps) => {
    const { t } = useTranslation();
    return (
        <div className="error-page-container">
            <div className={`error-page-content ${'error-page-is-global'}`}>
                <img className="error-page-logo" src={logo} alt="Azure Digital Twins" />
                <h2 className="error-page-header">{t('errorBoundary.modalHeader')}</h2>
                <div className="error-page-details">
                    <h3 className="error-page-message-header">{t('errorBoundary.messageHeader')}</h3>
                    <div className="error-page-message">
                        <pre>{error.name} | {error.message}</pre>
                    </div>
                    <h3 className="error-page-stack-header">{t('errorBoundary.stackHeader')}</h3>
                    <div className="error-page-stack">
                        <pre>{error.stack}</pre>
                    </div>
                </div>
                <div className="error-page-action-buttons">
                    <DefaultButton className="error-page-let-us-know-button" onClick={() => {
                        const launchOptions = {
                            telemetryGroup: {
                                errorCode: error.message,
                                errorName: error.stack
                            }
                        };
                        (window as any).OfficeBrowserFeedback.singleFeedback('Bug', launchOptions);
                    }}>{t('errorBoundary.letUsKnow')}</DefaultButton>
                    {
                        typeof resetErrorBoundary === 'function' &&
                        <DefaultButton className="error-page-try-again-button" onClick={resetErrorBoundary}>{t('errorBoundary.tryAgain')}</DefaultButton>
                    }
                </div>
            </div>
        </div>
    )
};

export default ErrorPage;